import * as s from "superstruct";

import { useErrorNotifier } from "components/instrumentation/source";
import { useBootstrap } from "components/store/source";

export interface ReturnType {
  stripePublishKey: string;
  adyenClientKey: string;
}

export const paymentGatewaysPublishableKeysSchema = s.object({
  stripePublishKey: s.string(),
  adyenClientKey: s.string(),
});

export const usePaymentGatewaysPublishableKeys = (): ReturnType | null => {
  const { paymentGatewaysPublishableKeys } = useBootstrap();
  const { notify } = useErrorNotifier();

  try {
    return s.create(
      paymentGatewaysPublishableKeys,
      paymentGatewaysPublishableKeysSchema,
    );
  } catch (error) {
    notify(
      error?.message ??
        "usePaymentGatewaysPublishableKeys parse failed from bootstrap.json",
    );
    return null;
  }
};
